var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@mui/material";
var ToolbarButtonGroup = function (_a) {
    var children = _a.children, sx = _a.sx;
    return (_jsx(Box, { sx: __spreadArray([
            {
                display: "inline-flex",
                alignItems: "stretch",
                height: 32,
                borderRadius: "6px",
                border: "1px solid rgba(255, 255, 255, 0.12)",
                backgroundColor: "rgba(255, 255, 255, 0.02)",
                overflow: "hidden",
                "& > *": {
                    border: "none !important",
                    borderRadius: "0 !important",
                    position: "relative",
                },
                "& > *:not(:last-child)": {
                    position: "relative",
                    "&::after": {
                        content: '""',
                        position: "absolute",
                        right: 0,
                        top: "20%",
                        height: "60%",
                        width: "1px",
                        backgroundColor: "rgba(255, 255, 255, 0.12)",
                    },
                },
            }
        ], (Array.isArray(sx) ? sx : sx ? [sx] : []), true), children: children }));
};
export default ToolbarButtonGroup;
